var map = {
	"./1before-destruction.png": 835,
	"./2bpost destruction2.png": 405,
	"./3bpost-destruction3.png": 431,
	"./beam.png": 156,
	"./gigachad punch dodge.png": 529,
	"./gigachadhole.png": 367,
	"./harold hit.png": 102,
	"./lava-level.png": 920,
	"./mages.png": 829,
	"./newlevel.png": 354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;